'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { ICON_STROKE_MAP } from './config.mjs';

const UnlinkIcon = ({ size = 24, ...props }, ref) => /* @__PURE__ */ jsx(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width: size,
    height: size,
    strokeWidth: ICON_STROKE_MAP[size],
    ref,
    "aria-hidden": true,
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M10.1833 5.6947L9.65293 6.22503L10.7136 7.28569L11.2439 6.75536L10.1833 5.6947ZM17.2543 12.7658L16.724 13.2961L17.7847 14.3568L18.315 13.8264L17.2543 12.7658ZM13.8233 18.3228L14.3536 17.7925L13.293 16.7318L12.7626 17.2621L13.8233 18.3228ZM6.22189 17.7925L5.69156 18.3228L6.22189 17.7925ZM6.75222 11.2517L7.28255 10.7214L6.22189 9.66073L5.69156 10.1911L6.75222 11.2517ZM11.2439 6.75536C12.9037 5.09563 15.5946 5.09563 17.2543 6.75536L18.315 5.6947C16.0695 3.44918 12.4288 3.44918 10.1833 5.6947L11.2439 6.75536ZM17.2543 6.75536C18.9141 8.41509 18.9141 11.106 17.2543 12.7658L18.315 13.8264C20.5605 11.5809 20.5605 7.94021 18.315 5.6947L17.2543 6.75536ZM12.7626 17.2621C11.1029 18.9219 8.41195 18.9219 6.75222 17.2621L5.69156 18.3228C7.93708 20.5683 11.5778 20.5683 13.8233 18.3228L12.7626 17.2621ZM6.75222 17.2621C5.09249 15.6024 5.09249 12.9115 6.75222 11.2517L5.69156 10.1911C3.44605 12.4366 3.44605 16.0773 5.69156 18.3228L6.75222 17.2621ZM8.99998 5.01581V1.99243H7.49998V5.01581H8.99998ZM5.02338 7.52732L2 7.52732L2 9.02732L5.02338 9.02732V7.52732ZM5.81409 4.74953L3.67624 2.61168L2.61558 3.67234L4.75343 5.81019L5.81409 4.74953ZM15.0078 18.9839V22.0073H16.5078V18.9839H15.0078ZM18.9844 16.4724H22.0078V14.9724H18.9844V16.4724ZM18.1937 19.2502L20.3315 21.388L21.3922 20.3274L19.2543 18.1895L18.1937 19.2502Z",
        fill: "currentColor"
      }
    )
  }
);
const VpUnlinkIcon = forwardRef(UnlinkIcon);

export { VpUnlinkIcon as default };
